import clsx from 'clsx';

export const LoadingImage = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div
    className={clsx('flex justify-center items-center self-center gap-half w-5 h-5 m-[1.25rem_auto]', className)}
    title="loading"
    {...props}
  >
    <LoadingImageItem />
    <LoadingImageItem style={{ animationDelay: '120ms' }} />
    <LoadingImageItem style={{ animationDelay: '240ms' }} />
  </div>
);

export const LoadingImageItem = ({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={clsx('w-[0.375rem] h-2 bg-gray-30 animate-loadingImageGrow', className)} {...props} />
);
